import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {authLoader} from '../../loader';
import {ROUTE_EFFORT_REPORT} from '../../RoutePathConstant';

const EffortReport = lazy(() =>
  import('../../../screens/EffortReport')
    .then(module => ({default: module.EffortReport})));

const EffortReportNavigation = [
  {
    path:  ROUTE_EFFORT_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <EffortReport />
      </Suspense>
    ),
  },
];

export default EffortReportNavigation;
